import React from 'react';
import notfound from './notfound.png'

function Notfound(props){
    return(
        <div className="notfoundContainer">
            <img src={notfound} alt="" />
        </div>
    )
}

export default Notfound;
